import type { RouteRecordRaw } from 'vue-router'

export const accountsRoutes: RouteRecordRaw[] = [
  {
    path: '/account',
    name: 'account',
    component: () => import('./pages/AccountPage.vue'),
    meta: { requiresAuth: true },
  },
]
